import {getEntity} from "../../../api-client";

export const getAudioGuide = (id) => {
    return getEntity("audio_guide", id);
}
